/**
 * Core utilities module exposed as `lpCoreUtils` angular constant object.
 * @name utils
 * @memberof core
 * @ngModule
 */

define(function (require, exports, module) {

    'use strict';

    module.name = 'core.utils';

    var base = require('base');

    /**
     * @name lpCoreUtils
     * @memberof core.utils
     * @ngConstant
     */
    var utils = base.utils;

    var url = require('./url');
    var date = require('./date');
    var portal = require('./portal');
    var is = require('./is');
    var parse = require('./parse');
    var string = require('./string');
    var cookie = require('./cookie');
    var ngUtils = require('./ng');
    var parseAmount = require('./parse-amount');
    var getTransferGroupTitle = require('./transfer-group-title');
    var toTitleCase = require('./to-title-case');
    var extractNumber =require('./extractNumber');
    var hasVisibilityRole = require('./button-visibility-filter');
    var mobileOtpWindow = require('./mobile-otp-window');
    var mobileDialog = require('./mobile-dialog');
    var dateConversion = require('./date-conversion');

    utils.mixin(url);
    utils.mixin(date);
    utils.mixin(portal);
    utils.mixin(is);
    utils.mixin(parse);
    utils.mixin(string);
    utils.mixin(cookie);
    utils.mixin(ngUtils);
    utils.mixin(parseAmount);
    utils.mixin(getTransferGroupTitle);
    utils.mixin(toTitleCase);
    utils.mixin(extractNumber);
    utils.mixin(hasVisibilityRole);
    utils.mixin(mobileOtpWindow);
    utils.mixin(mobileDialog);
    utils.mixin(dateConversion);

    module.exports = base.createModule( module.name, [])
        .constant( { 'lpCoreUtils': utils });
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/main.js
// module id = 26
// module chunks = 0